import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import ChainInfo from "./pages/ChainInfo";
import FakeBayc from "./pages/FakeBayc";
import FakeBaycDetail from "./pages/FakeBaycDetail";
import FakeNefturians from "./pages/FakeNefturians";
import FakeNefturiansUser from "./pages/FakeNefturiansUser";
import FakeMeebits from "./pages/FakeMeebits";

import "./App.css"; // Optional: Add basic styling here

function App() {
  return (
    <Router>
      <div className="app-container" style={{ padding: "20px", fontFamily: "sans-serif" }}>
        <nav style={{ paddingBottom: "15px", borderBottom: "1px solid #ddd", marginBottom: "20px" }}>
          <Link style={{ marginRight: "15px" }} to="/chain-info">Chain Info</Link>
          <Link style={{ marginRight: "15px" }} to="/fakeBayc">Fake BAYC</Link>
          <Link style={{ marginRight: "15px" }} to="/fakeNefturians">Fake Nefturians</Link>
          <Link style={{ marginRight: "15px" }} to="/fakeMeebits">Fake Meebits</Link>
        </nav>

        <Routes>
          <Route path="/chain-info" element={<ChainInfo />} />
          
          {/* BAYC Routes */}
          <Route path="/fakeBayc" element={<FakeBayc />} />
          <Route path="/fakeBayc/:tokenId" element={<FakeBaycDetail />} />
          
          {/* Nefturians Routes */}
          <Route path="/fakeNefturians" element={<FakeNefturians />} />
          <Route path="/fakeNefturians/:userAddress" element={<FakeNefturiansUser />} />
          
          {/* Meebits Routes */}
          <Route path="/fakeMeebits" element={<FakeMeebits />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;